import { Chip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { memo, useMemo } from 'react'
import { BsQuestionCircle } from 'react-icons/bs'

import { Question } from '@/types'

interface QuestionCardTypeProps {
  question: Pick<Question, 'type'>
}

export const QuestionCardType = memo<QuestionCardTypeProps>(({ question }) => {
  const theme = useTheme()

  const typeConfig = useMemo(
    () => ({
      'multiple choice': {
        label: 'Múltipla escolha',
        color: theme.palette.primary.main,
      },
      discursive: {
        label: 'Discursiva',
        color: theme.palette.secondary.main,
      },
    }),
    [theme],
  )

  const config = typeConfig[question.type] || typeConfig['multiple choice']

  return (
    <Chip
      data-qa="question-card-type"
      icon={<BsQuestionCircle size={14} />}
      label={config.label}
      variant="outlined"
      sx={{
        borderColor: config.color,
        color: config.color,
        backgroundColor: `${config.color}08`,
        fontWeight: 500,
        borderRadius: 2,
        px: 0.5,
        '& .MuiChip-icon': {
          color: config.color,
        },
      }}
    />
  )
})

QuestionCardType.displayName = 'QuestionCardType'
